import { TooltipWrapper } from 'components/TooltipWrapper';
import type { CatalogWorkTypeData } from 'gql/graphql';
import type { IUseAccess } from 'hooks/useAccess';
import type { CheckboxPropOnChange } from 'uikit';
import { Checkbox } from 'uikit';

import type React from 'react';

interface ICheckRowCell {
    row: CatalogWorkTypeData;
    onChange?: CheckboxPropOnChange | undefined;
    checkedIds: Record<string, boolean>;
    catalogTypesOfWorkRules: IUseAccess['catalogTypesOfWork'];
}

export const CheckRowCell: React.FC<ICheckRowCell> = (props) => {
    const { onChange, row, checkedIds, catalogTypesOfWorkRules } = props;

    const { id } = row;

    const disabledCheckbox = row.hasPrice || !catalogTypesOfWorkRules.canDelete;

    return (
        <TooltipWrapper
            message="Имеется связь с расценкой"
            isHidden={!disabledCheckbox}
            size="m"
            direction="rightCenter"
        >
            <Checkbox disabled={disabledCheckbox} checked={checkedIds[id]} onChange={onChange} />
        </TooltipWrapper>
    );
};

CheckRowCell.displayName = 'CheckRowCell';
